/**
 * Scrolls to an element with a specified ID, with a header offset
 * @param elementId - The ID of the element to scroll to
 * @param headerOffset - The offset from the top (default: 100px for fixed header)
 */
export const scrollToElement = (
  elementId: string,
  headerOffset: number = 100
) => {
  const targetElement = document.getElementById(elementId);

  if (targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};
